export const setupGamera = ({ adSlots, userData }) => {
	// US only
	if (userData?.countryCode?.toLowerCase() !== 'us') {
		return;
	}

	// this is temporary to ensure a seamless transtion from ad server to page. I'll look for this value in the ad server code and if true, not load the ad server code.
	window.gameraFromPage = true;

	let aw_page = '',
		aw_gam_code = '',
		aw_partner = '',
		aw_wx_seg = '';
	let ltv = 1;

	try {
		if (adSlots) {
			aw_gam_code = Object.values(adSlots)[0].adUnitCode;
		}

		aw_page = window.RaineV2?.pageView?.pageInfo?.group || '';
		aw_partner = window?.adInfo?.partner || 'accuweather';
		aw_wx_seg = window?.adInfo?.wx_seg || '';
		ltv = 1;
	} catch (e) {
		window.awxLogger
			?.withScope('Ads::setupGamera')
			.debug('Error getting Gamera data from adSlots or window.adInfo', e);
	}

	window.gamera = window.gamera || {};
	window.gamera.cmd = window.gamera.cmd || [];
	window.gamera.cmd.push(function () {
		window.logAdEvent('Gamera initialized');

		//custom dimensions
		window.gamera.addDimensions({
			aw_site: aw_gam_code.split('/')[2],
			aw_wxGeo: aw_gam_code.split('/')[3],
			aw_page: aw_page.replace('/', ''),
			aw_partner: aw_partner,
			aw_wx_seg: aw_wx_seg,
			aw_sub: window?.adInfo?.sub || '',
		});

		//Gamera have a new getUserMetrics() method to simplify retreival of user metrics

		//average CPM
		try {
			let ucpm = window?.gamera?.getUserMetrics()?.avg_cpm || undefined;
			if (ucpm) {
				ucpm = (Math.round(ucpm * 20) / 20).toFixed(2);
				window.adInfo.ucpm = ucpm;
			}
		} catch (e) {
			window.awxLogger
				?.withScope('Ads::setupGamera')
				.debug('Error getting ucpm from Gamera', e);
		}

		//average fillrate
		try {
			let ufill = window?.gamera?.getUserMetrics()?.avg_fillrate || undefined;
			if (ufill) {
				ufill = (Math.round(ufill * 20) / 20).toString();
				window.adInfo.ufill = ufill;
			}
		} catch (e) { }

		//Historical Visits
		try {
			let uvists = window?.gamera?.getUserMetrics()?.visits || undefined;
			if (uvists) {
				if (uvists.last_7) {
					window.adInfo.uvisits_7 = uvists.last_7.toString();
				}
				if (uvists.last_14) {
					window.adInfo.uvisits_14 = uvists.last_14.toString();
				}
				if (uvists.last_30) {
					window.adInfo.uvisits_30 = uvists.last_30.toString();
				}
				if (uvists.lifetime) {
					window.adInfo.uvisits_life = uvists.lifetime.toString();
				}
			}
		} catch (e) { }

		//cohort
		try {
			let cohort = window?.gamera?.getOnPageSegments()?.filter((cpm) => !/^user_/.test(cpm)).join(",") || undefined;
			if (cohort) {
				window.adInfo.cohort = cohort;
			}
		} catch (e) { }

		//IAB Audience Taxonomy Code
		try {
			let iabatax = window?.gamera?.getPrebidSegments()?.user?.data[0]?.segment?.map(a => a.id).join(',') || undefined;
			if (iabatax) {
				window.adInfo.iabatax = iabatax;
			}
		} catch (e) {
			window.awxLogger
				?.withScope('Ads::setupGamera')
				.debug('Error getting cohort from Gamera', e);
		}
	});

	// Add the Gamera tag
	const s = document.createElement('script');

	s.setAttribute('id', '__gamera__');
	s.setAttribute('async', 'true');
	s.src = `https://metrics.rapidedge.io/gamera.js?domain=accuweather.com&ltv=${ltv}&tpcs=1`;

	const el = document.getElementsByTagName('script')[0];
	if (el) {
		el.parentNode.insertBefore(s, el);
	} else {
		window.logAdEvent('Error adding Gamera script tag');
	}
};
